import { Injectable } from '@angular/core';
import { EsPage } from '../../../../models/es-page';
import { Aggregate } from '../../../../models/aggregate';
import { CdxTask } from '../../../../models/cdx-task';
import { createAction, props, Store } from '@ngrx/store';

export class TaskSearchResultConstantAction {
  static readonly LOAD_RESULT_ITEMS_START = '[TasksSearch]: LOAD_RESULTS_START';
  static readonly LOAD_RESULT_ITEMS_SUCCEEDED = '[TasksSearch]: LOAD_RESULTS_SUCCEEDED';
  static readonly LOAD_RESULT_ITEMS_FAILED = '[TasksSearch]: LOAD_RESULTS_FAILED';
  static readonly ERROR_START = 'ERROR_START';

  static readonly LOAD_AGGREGATE_START = '[TasksSearch]: LOAD_AGGREGATE_START';
  static readonly LOAD_AGGREGATE_SUCCEEDED = '[TasksSearch]: LOAD_AGGREGATE_SUCCEEDED';
  static readonly LOAD_AGGREGATE_FAILED = '[TasksSearch]: LOAD_AGGREGATE_FAILED';

  static readonly UPDATE_TASKS_START = '[TasksSearch]: UPDATE_TASKS_START';
  static readonly UPDATE_TASKS_SUCCEEDED = '[TasksSearch]: UPDATE_TASKS_SUCCEEDED';
  static readonly UPDATE_TASKS_FAILED = '[TasksSearch]: UPDATE_TASKS_FAILED';

  static readonly UPDATE_TASK_SUCCEEDED = '[TasksSearch]: UPDATE_TASK_SUCCEEDED';

  static readonly UPDATE_SOME_TASKS_START = '[TasksSearch]: UPDATE_SOME_TASKS_START';
  static readonly UPDATE_SOME_TASKS_SUCCEEDED = '[TasksSearch]: UPDATE_SOME_TASKS_SUCCEEDED';
  static readonly UPDATE_SOME_TASKS_FAILED = '[TasksSearch]: UPDATE_SOME_TASKS_FAILED';

  static readonly REMOVE_SOME_TASKS_START = '[TasksSearch]: REMOVE_SOME_TASKS_START';
  static readonly REMOVE_SOME_TASKS_SUCCEEDED = '[TasksSearch]: REMOVE_SOME_TASKS_SUCCEEDED';
  static readonly REMOVE_SOME_TASKS_FAILED = '[TasksSearch]: REMOVE_SOME_TASKS_FAILED';
}

export const loadResultItemsStartAction = createAction(TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_START);
export const loadResultItemsSucceededAction = createAction(TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const loadResultItemsFailedAction = createAction(TaskSearchResultConstantAction.LOAD_RESULT_ITEMS_FAILED,props<{error:Error}>());
export const loadAggregateStartAction = createAction(TaskSearchResultConstantAction.LOAD_AGGREGATE_START);
export const loadAggregateSucceededAction = createAction(TaskSearchResultConstantAction.LOAD_AGGREGATE_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const loadAggregateFailedAction = createAction(TaskSearchResultConstantAction.LOAD_AGGREGATE_FAILED,props<{error:Error}>());
export const updateTasksStartAction = createAction(TaskSearchResultConstantAction.UPDATE_TASKS_START);
export const updateTasksSucceededAction = createAction(TaskSearchResultConstantAction.UPDATE_TASKS_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const updateTasksFailedAction = createAction(TaskSearchResultConstantAction.UPDATE_TASKS_FAILED,props<{error:Error}>());
export const updateTaskSucceededAction = createAction(TaskSearchResultConstantAction.UPDATE_TASK_SUCCEEDED, props<{payload:EsPage<CdxTask>}>());
export const updateSomeTasksStartAction = createAction(TaskSearchResultConstantAction.UPDATE_SOME_TASKS_START);
export const updateSomeTasksSucceededAction = createAction(TaskSearchResultConstantAction.UPDATE_SOME_TASKS_SUCCEEDED,props<{payload:CdxTask[]}>());
export const updateSomeTasksFailedAction = createAction(TaskSearchResultConstantAction.UPDATE_SOME_TASKS_FAILED,props<{error:Error}>());
export const removeSomeTasksStartAction = createAction(TaskSearchResultConstantAction.REMOVE_SOME_TASKS_START);
export const removeSomeTasksSucceededAction = createAction(TaskSearchResultConstantAction.REMOVE_SOME_TASKS_SUCCEEDED,props<{payload:CdxTask[]}>());
export const removeSomeTasksFailedAction = createAction(TaskSearchResultConstantAction.REMOVE_SOME_TASKS_FAILED,props<{error:Error}>());


@Injectable({
  providedIn: 'root'
})
export class TaskSearchResultAction {


  constructor( private localStore: Store ) {
  }

  public loadTasksStarted() {
    this.localStore.dispatch(loadResultItemsStartAction());
  }

  public loadTasksSucceeded(payload: EsPage<CdxTask>) {
    this.localStore.dispatch(loadResultItemsSucceededAction({payload}));
  }

  public loadTasksFailed(error: any) {
    this.localStore.dispatch(loadResultItemsFailedAction({error}));
  }



  public loadAggregateStart() {
    this.localStore.dispatch(loadAggregateStartAction());
  }

  public loadAggregateFailed(error: any) {
    this.localStore.dispatch(loadAggregateFailedAction({error}));
  }

  public loadAggregateSucceeded(agg: Aggregate) {
    const payload: EsPage<CdxTask> = new EsPage<CdxTask>(0, [], 0, 0, [agg], false);
    this.localStore.dispatch(loadAggregateSucceededAction({payload}));
  }

  public updateTasksStarted() {
    this.localStore.dispatch(updateTasksStartAction());
  }

  public updateTasksSucceeded(payload: EsPage<CdxTask>) {
    this.localStore.dispatch(updateTasksSucceededAction({payload}));
  }

  public updateTasksFailed(error: any) {
    this.localStore.dispatch(updateTasksFailedAction({error}));
  }

  updateTaskSucceeded( cdxTask: CdxTask ) {
    const page: EsPage<CdxTask> = new EsPage<CdxTask>(0, [cdxTask], 0, 0, [], false);
    this.localStore.dispatch(updateTaskSucceededAction({payload: page}));
  }

  public updateSomeTasksStarted() {
    this.localStore.dispatch(updateSomeTasksStartAction());
  }

  public updateSomeTasksSucceeded(payload: CdxTask[]) {
    this.localStore.dispatch(updateSomeTasksSucceededAction({payload}));
  }

  public updateSomeTasksFailed(error: any) {
    this.localStore.dispatch(updateSomeTasksFailedAction({error}));
  }

  public removeSomeTasksStarted() {
    this.localStore.dispatch(removeSomeTasksStartAction());
  }

  public removeSomeTasksSucceeded(payload: CdxTask[]) {
    this.localStore.dispatch(removeSomeTasksSucceededAction({payload}));
  }

  public removeSomeTasksFailed(error: any) {
    this.localStore.dispatch(removeSomeTasksFailedAction({error}));
  }
}
